import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as collections from '../collections/redux/actions';
import * as plugin from '../plugin/redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { PromptDataDisplay } from '../collections/PromptDataDisplay';
import { getFilteredCollections, iconStyle } from './utils';
import CustomLoader from '../common/CustomLoader';

export class PromptCollectionsList extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  state = {
    createdCollections: [],
    removedCollectionTitles: [],
    collectionAndCreateAppPending: false,
    systemRoles: [],
  };
  async componentDidMount() {
    const { collections, projectId, version, plugin } = this.props;
    const coll = await collections.loadProjectCollections({ projectId, version });
    const systemRoles = await plugin.loadRoles({ projectId, version });
    
    this.setState({ systemRoles: systemRoles.data });
    this.setState({ createdCollections: coll.data });

    window.onbeforeunload = (event) => {
      const message = 'If you reload this page, data will be lost. Are you sure?';
      event.returnValue = message;
      return message;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  handleFinalPromptSubmit = async (jsonConfig) => {
    const { collections, projectId, version } = this.props;
    const data = {
      ...jsonConfig,
      projectId,
      version,
      shouldUpdateIfExists: true,
      isCreateEvents: true,
    };
    await collections.createCollectionWithPrompt(data);
    const allCollections = await collections.loadProjectCollections({ projectId, version });
    this.setState({
      createdCollections: allCollections.data,
    });
  };

  handleRemoveCollection = (collectionTitle) => {
    this.setState((prevState) => ({
      removedCollectionTitles: [...prevState.removedCollectionTitles, collectionTitle],
    }));
  };

  showCollectionsList = (collection) => {
    const { REACT_APP_AI_MODEL } = process.env;
    const { fields, collectionTitle, uuid } = collection;
    let formattedFieldTitles = [];
    if (collection && fields) {
      formattedFieldTitles = fields.map((field) => ({
        title: (field.fieldTitle && field.fieldTitle.en) || 'Untitled',
        type: field.type || 'text',
      }));
    }

    const isSystemCollection = collectionTitle === 'User' || collectionTitle === 'Role';
    const isSavedCollection = !!uuid;
    const displayTitle = isSystemCollection
      ? `${collectionTitle} (System Default)`
      : collectionTitle;

    return (
      <AccordionItem uuid={collectionTitle} key={collectionTitle}>
        <AccordionItemHeading>
          <AccordionItemButton style={{ position: 'relative' }}>
            <strong>
              <span>{displayTitle}</span>
            </strong>
            {!isSystemCollection && !isSavedCollection ? (
              <button
                type="button"
                className="btn btn-sm btn-link text-danger"
                title="Remove Collection"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleRemoveCollection(collectionTitle);
                }}
                style={{
                  ...iconStyle,
                  padding: '0',
                  lineHeight: '1',
                }}
              >
                <i className="wb webconnect-trash-regular"></i>
              </button>
            ) : (
              <i
                className="wb webconnect-check-circle"
                style={{
                  ...iconStyle,
                  color: '#93a828',
                }}
                title="Saved"
              ></i>
            )}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <PromptDataDisplay
            extractedFields={[fields]}
            promptFields={formattedFieldTitles}
            promptName={collectionTitle}
            selectedAIModel={REACT_APP_AI_MODEL || 'OPEN_AI'}
            onUpdateJsonConfig={(config) => {
              console.log('Updated JSON Config:', config);
            }}
            onSubmit={this.handleFinalPromptSubmit}
            showCancel={false}
            isSavedCollection={isSavedCollection}
          />
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  handleSaveAndContinue = async () => {
    const {
      collections,
      projectId,
      version,
      promptCollections = [],
      actions,
      history,
      home,
      rolesList,
      userPrompt,
    } = this.props;
    const { removedCollectionTitles, systemRoles } = this.state;
    try {
      this.setState({ collectionAndCreateAppPending: true });
      const { data: storedCollections = [] } = await collections.loadProjectCollections({
        projectId,
        version,
      });
      const storedNames = storedCollections.map((collection) =>
        collection.orgCollectionName.toLowerCase(),
      );

      const dataForSave = promptCollections.filter(
        (collection) =>
          collection.collectionTitle &&
          !storedNames.includes(collection.collectionTitle.toLowerCase()) &&
          !removedCollectionTitles.includes(collection.collectionTitle),
      );
      const bulkcollectionResponse = await actions.createBulkCollections({
        dataForSave,
        projectId,
        version,
        isCreateEvents: true,
      });
      if (bulkcollectionResponse.data) {
        history.push({
          pathname: `/ai-prompt-builder/${version}/v/${projectId}/roles-list`,
          state: {
            rolesData: rolesList,
            systemRoles: JSON.parse(JSON.stringify(systemRoles)),
            userPrompt,
          },
        });
      }
    } catch (error) {
      console.error('Error in handleSaveAndContinue:', error);
    } finally {
      this.setState({ collectionAndCreateAppPending: false });
    }
  };

  render() {
    const { promptCollections = [], projectId, version } = this.props;
    const { createdCollections, removedCollectionTitles, collectionAndCreateAppPending } =
      this.state;

    const filteredCollections = getFilteredCollections(
      promptCollections,
      createdCollections,
    ).filter((collection) => !removedCollectionTitles.includes(collection.collectionTitle));

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentContentCard title="Generated Collections List" icon="aiModelConfig">
              <div className="center-div mb-4">
                <div className="container ml-0">
                  <h5 className="mb-3 text-center">
                    The following collections have been generated based on your prompt. You can
                    review and modify them below.
                  </h5>
                </div>
              </div>
              {filteredCollections.length > 0 ? (
                <Accordion
                  allowZeroExpanded
                  preExpanded={[
                    filteredCollections.length > 0 ? filteredCollections[0].collectionTitle : '',
                  ]}
                >
                  {filteredCollections.map((collection) => this.showCollectionsList(collection))}
                </Accordion>
              ) : (
                <h4 className="text-center mt-4">No Collections Created</h4>
              )}
            </ParentContentCard>
            <div className="col-12 mt-0 text-right">
              <div className="container1">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <button
                    className="btn btn-theme-submit btn-md"
                    onClick={this.handleSaveAndContinue}
                    title="Save & Go to Next Step"
                    disabled={collectionAndCreateAppPending}
                  >
                    <i className="wb webconnect-save-regular"></i>&nbsp;Create Collections &
                    continue to next step
                    <CustomLoader loading={collectionAndCreateAppPending} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    collections: state.collections,
    home: state.home,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    collections: bindActionCreators({ ...collections }, dispatch),
    plugin: bindActionCreators({ ...plugin }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PromptCollectionsList);
